import React from 'react';

const HeadingContext = React.createContext<number>(1);

export default HeadingContext;
